import React from "react";
import StringInput from "../formElements/StringInput";
import {useParams} from "react-router-dom";
import BooleanInput from "../formElements/BooleanInput";
import IntegerInput from "../formElements/IntegerInput";
import GenericForm from "./GenericForm";


function AddressForm(props) {

    const {companyName, id} = useParams()

    function parseData(newData) {
        newData.Firma = companyName
        return {...newData}
    }

    const formContent = (data, update) => (
        <>
            <BooleanInput name={'Hlavna_Adresa'} label={'Hlavná Adresa'} value={data.Hlavna_Adresa}
                          onChange={update}/>
            <StringInput name={'Nazov'} label={'Názov'} value={data.Nazov} onChange={update}/>
            <StringInput name={'Ulica'} label={'Ulica'} value={data.Ulica} onChange={update}/>
            <StringInput name={'Mesto'} label={'Mesto'} value={data.Mesto} onChange={update}/>
            <IntegerInput name={'PSC'} label={'PSČ'} value={data.PSC} onChange={update}/>
        </>
    )

    return (
        <GenericForm label={`Adresa Firmy: ${companyName}`}
                     labelNew={`Pridať Adresu Firmy: ${companyName}`}
                     baseUrl='/company/addresses/'
                     id={id}
                     parseData={parseData}
                     formContent={formContent}/>
    )
}

export default AddressForm
